

module.exports = __webpack_require__.stylable.create(
    "TabsNavButton445131168",
    {"classes":{"root":"TabsNavButton445131168__root","border":"TabsNavButton445131168__border"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "TabsNavButton445131168",
    null
);
